import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Config} from "../config";

@Injectable()
export class TooltipsService {

  private tooltips;

  constructor(private http: HttpClient) { }

  getTooltips (): Promise<any> {
    if (this.tooltips) return new Promise((resolve) => {
      resolve(this.tooltips);
    });

    return new Promise((resolve) => {
      const url = Config.BASE_URL + 'tooltips/?show_all=true';
      this.http.get(url).subscribe((res: any) => {
        this.tooltips = res.results;
        resolve(res);
      });
    });
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/tooltips.service.ts